import React, { FC } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import SVGIcon from '@styles/icons/svg';
import { STEPPER_BUTTON_CONFIG, StepperButtonType } from './constants';
import type { StepperButtonProps } from './types';

const StepperButton: FC<StepperButtonProps> = ({ type, onPress, disabled = false, size = 44, scale = initialScale, C }) => {
  const config = STEPPER_BUTTON_CONFIG[type];
  if (!config) return null;
  const { icon, iconWidth, iconHeight, backgroundColor, textColor } = config;

  return (
    <TouchableElement onPress={onPress} disabled={disabled}>
      {({ pressHoverColor, boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              width: scale(size),
              height: scale(size),
              borderRadius: scale(size / 2),
              backgroundColor: C(pressHoverColor(backgroundColor)),
              justifyContent: 'center',
              alignItems: 'center',
              opacity: disabled ? 0.3 : 1,
            },
          ]}
        >
          <SVGIcon icon={icon} color={textColor} width={scale(iconWidth)} height={scale(iconHeight)} C={C} />
        </View>
      )}
    </TouchableElement>
  );
};

export { StepperButtonType };
export default StepperButton;
